import { Component, EventEmitter, Input, Output, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';

export interface ActionDockButton {
  id: string;
  icon: string;
  label?: string;
  hasData?: boolean;
}

@Component({
  selector: 'tidy-action-dock',
  templateUrl: './action-dock.component.html',
  styleUrls: ['./action-dock.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ActionDockComponent {
  @Input() heroText = 'Book Cleaning';
  @Input() heroIcon = 'calendar_today';
  @Input() actions: ActionDockButton[] = [];
  @Input() selectedAction: string | null = null;
  @Output() heroClick = new EventEmitter<void>();
  @Output() actionClick = new EventEmitter<string>();

  onHeroClick(): void {
    this.heroClick.emit();
  }

  onActionClick(action: ActionDockButton): void {
    this.actionClick.emit(action.id);
  }

  isSelected(action: ActionDockButton): boolean {
    return this.selectedAction === action.id;
  }
}
